export default __webpack_public_path__ + "static/media/featured-2.9de94412.jpeg";